export default __webpack_public_path__ + "static/media/Mask Group 12.54cac650.jpg";